export default function parseSources(data) {
    let sources = {}, fallback = null;

    data.sort((a, b) => (parseInt(a.size) < parseInt(b.size)) ? 1 : -1);
    data.forEach((item, index) => {
        if (index === data.length-1) 
            fallback = item.src;
            
        if(parseInt(item.size) !== 0)
        sources['(min-width: '+item.size+'px)'] = item.src;
    });

    return [fallback, sources];
}
